import { lazy, Suspense } from 'react';
import './App.css';
import FirstScreen from './screens/FirstScreen';

/*
 * Only the hero (FirstScreen) is part of the initial bundle. Everything below
 * the fold is split into async chunks so the first paint carries as little JS
 * as possible. The chunks are all requested in parallel as soon as the main
 * bundle finishes evaluating, so they are in place long before the visitor
 * scrolls down to them.
 */
const SecondScreen = lazy(() => import('./screens/SecondScreen'));
const AboutIdit = lazy(() => import('./components/me/Me'));
const ThirdScreen = lazy(() => import('./screens/ThirdScreen'));
const ForthScreen = lazy(() => import('./screens/ForthScreen'));
const FifthScreen = lazy(() => import('./screens/FifthScreen'));
const Sixthscreen = lazy(() => import('./screens/SixthScreen'));
const PrivacyPolicy = lazy(() => import('./components/privacy copy/Privacy'));
const ByMe = lazy(() => import('./components/ByMe/ByMe'));

// Sized placeholder, not a spinner: it reserves a viewport of height so the
// scroll position does not jump when the deferred sections arrive.
const SectionFallback = () => <div style={{ minHeight: '100vh' }} aria-hidden="true" />;

function App() {

  return <>
  <div style={{overflowX:"hidden"}}>
  <FirstScreen/>
  <Suspense fallback={<SectionFallback />}>
  <SecondScreen/>
 <AboutIdit/>
  <ThirdScreen/>
  <ForthScreen/>
<FifthScreen/>
<Sixthscreen/>
       <PrivacyPolicy
  ownerName="עידית בזק"
  email="idit003@gmail.com"
  phone="+972 52-775-2556"
  domain="https://iditbazak-facecare.co.il/"
/>
  <ByMe/>
  </Suspense>
  </div>
  </>
}

export default App;
